// @ts-strict-ignore
import type {
  EngagementAppGroupIdFeatureLimitationsProps,
  FeatureLimitation,
  FeatureLimitationsKey,
} from "@dashboardApi/apis/engagementAppGroupIdFeatureLimitations";

import { useAppGroupId } from "@services/useAppGroupId";
import { useDashboardApiQuery } from "@services/useDashboardApi";

export const useEngagementAppGroupIdFeatureLimitationApiQuery = <Key extends FeatureLimitationsKey>(
  limitDataItem: EngagementAppGroupIdFeatureLimitationsProps<Key>
) => {
  const appGroupId = useAppGroupId();
  return useDashboardApiQuery("/engagement/:app_group_id/feature_limitations", {
    params: [appGroupId, [limitDataItem]],
    options: {
      select: (data) => data[0] as FeatureLimitation<Key>,
    },
  });
};
